import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import CONFIG from '../../config';
import news from './de_news';
import projects from './de_projects';

export default Object.assign({
    FORMAT_DATE: 'd.m.Y',

    NAV_HOME: 'Home',
    NAV_ABOUT: 'INM',
    NAV_NEWS: 'News',
    NAV_PROJECTS: 'Projekte',
    NAV_CONTACT: 'Kontakt',

    NAV_FAQ: 'FAQ',
    NAV_IMPRINT: 'Impressum',
    NAV_SITEMAP: 'Sitemap',

    FOOTER_IDL_TITLE: 'IDL - Für ein freies Internet',
    FOOTER_SETTINGS_HEAD: 'Einstellungen',
    FOOTER_SETTINGS_DESCRIPTION: 'Hier kannst du das WikINM für dich anpassen.',
    FOOTER_SETTINGS_OPTION_COOKIES: 'Cookies',
    FOOTER_SETTINGS_OPTION_COOKIES_ALERT: 'Zur Zeit werden ausschließlich Cookies gespeichert, die für das Speichern der Einstellungen notwendig sind.',
    FOOTER_MORE_LINKS_HEAD: 'Mehr...',

    FOOTER_SUGGESTIONS: 'Verbesserungsvorschläge',

    IMPRINT_HEAD: 'Impressum',
    IMPRINT_CONTACT_HINT: <Fragment>Gerne kannst du uns <Link to={CONFIG.ROUTES.CONTACT}>hier</Link> kontaktieren.</Fragment>,

    ABOUT_INFO: <Fragment>
        <p><strong>INM</strong> ist eine "Gruppe", die haupsächlich <a href="https://de.wikipedia.org/wiki/Machinima" target="_blank" rel="noopener noreferrer">Machinimas</a> erstellt.</p>
        <p>
            Sie besteht momentan aus einem <a href="#team">Team</a> von 8 Leuten und erstellt größtenteils <a href="https://de.wikipedia.org/wiki/Machinima" target="_blank" rel="noopener noreferrer">Machinimas</a> mit der Multiplayer-Modifikation <a href="https://www.sa-mp.com/" target="_blank" rel="noopener noreferrer">SAMP</a>, sowie mit <a href="https://de.wikipedia.org/wiki/Grand_Theft_Auto_V#GTA_Online" target="_blank" rel="noopener noreferrer">Grand Theft Auto Online</a> (dem Online-Modus von <a href="https://de.wikipedia.org/wiki/Grand_Theft_Auto_V" target="_blank" rel="noopener noreferrer">Grand Theft Auto V</a>).<br />
            SAMP ist eine Multiplayer-Erweiterung für das Spiel <a href="https://de.wikipedia.org/wiki/Grand_Theft_Auto:_San_Andreas" target="_blank" rel="noopener noreferrer">Grand Theft Auto: San Andreas</a>.<br />
            Vertreten ist INM ausschließlich auf <a href="https://www.youtube.com/user/wesoneakaINM" target="_blank" rel="noopener noreferrer">YouTube</a>.
        </p>
        <p>
            Begonnen hat alles auf den Videoplattformen <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a> und <a href="https://www.youtube.com/" target="_blank" rel="noopener noreferrer">YouTube</a>.
            Als "Myth crew" wurden dort Videos veröffentlicht, die sich mit den Mythen um das Spiel <a href="https://de.wikipedia.org/wiki/Grand_Theft_Auto:_San_Andreas" target="_blank" rel="noopener noreferrer">Grand Theft Auto: San Andreas</a> auseinandersetzten.
            Dazu gehört der - wohl am bekanntesten verbreitete - "Alien Mythos".
        </p>
        <p>
            Später begann INM mit dem ersten Machinima <a href={CONFIG.ROUTES.PROJECTS + '#Restless Survivors'}>Restless Survivors</a>.
        </p>
        <p>
            Aufgrund der geringen User-Dichte auf <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a>, beschloss wesone endgültig zu <a href="https://www.youtube.com/user/wesoneakaINM" target="_blank" rel="noopener noreferrer">YouTube</a> zu wechseln und gab <a href="https://www.myvideo.de/" target="_blank" rel="noopener noreferrer">MyVideo</a> auf.
        </p>
    </Fragment>,
    ABOUT_MEMBER_DEFAULT: '-',
    ABOUT_MEMBER_wesone: <Fragment><span className="font-weight-bold">wesone</span> wurde in Las Venturas geboren und wuchs dort auf. Er ist der Gründer von INM und auch der Produzent der Videos. Er ist für die Storyline, die Kamera, den Schnitt und die Bearbeitung verantwortlich.</Fragment>,
    ABOUT_MEMBER_killerman: <Fragment><span className="font-weight-bold">killerman</span> wuchs im gefährlichen Ghettoviertel Ganton im Osten Los Santos' auf. Er saß 4 Jahre hinter Gittern wegen Drogenhandel. Dann wurde er Mitglied bei INM.</Fragment>,
    ABOUT_MEMBER_Deadwood: <Fragment><span className="font-weight-bold">Deadwood</span> lebt in Bayside. Er war damals eher als Aushilfe zuständig, gehörte jedoch nach kurzer Zeit mit zum Team (Deadwood und wesone waren bereits vorher private Freunde).</Fragment>,
    ABOUT_MEMBER_NoX: <Fragment><span className="font-weight-bold">NoX</span> ist der Erbe eines Millionenimperiums und hat sich um Geld nie viel Sorgen machen müssen. Hin und wieder sitzt er vor Gericht wegen Autodiebstahl, betrunken Autofahren, Fahren ohne Führerschein und Schießen auf seine Nachbarn. Da er sich die Kaution jedoch aus dem Ärmel schütteln kann, ist das sein geringstes Problem. Er arbeitet eng mit wesone zusammen und steht sowohl als Darsteller als auch als treues Mitglied zur Verfügung.</Fragment>,
    ABOUT_MEMBER_SergejVodkakov: <Fragment><span className="font-weight-bold">SergejVodkakov</span> ist Mitgründer von INM. Er hält sich jedoch oft aus dem Erstellen der Geschichten heraus und gibt sich oft nur als Darsteller.</Fragment>,
    ABOUT_MEMBER_Poulsen: <Fragment><span className="font-weight-bold">Poulsen</span> und wesone verbindet eine enge Freundschaft, da sie zusammen in Las Venturas aufwuchsen. Daher trat Poulsen auch nach einiger Zeit dem Team bei.</Fragment>,
    ABOUT_MEMBER_Neon: <Fragment>Naja... Das ist <span className="font-weight-bold">Neon</span>.</Fragment>,
    ABOUT_MEMBER_Jacqui: <Fragment><span className="font-weight-bold">Jacqui</span> ist das neuste Mitglied bei INM. Sie war ein großer Fan von INM und gehörte nach langer Zeit zum Team."</Fragment>,

    NEWS_PLANNED: 'Geplante Projekte',

    PROJECTS_CAROUSEL_NEXT: 'Weiter',
    PROJECTS_CAROUSEL_PREV: 'Zurück',
    PROJECTS_RELEASED_ON: 'Erschienen am',
    PROJECTS_TRIVIA: 'Trivia',

    CONTACT_NAME: 'Name',
    CONTACT_EMAIL: 'E-Mail-Adresse',
    CONTACT_SUBJECT: 'Betreff',
    CONTACT_MESSAGE: 'Nachricht',
    CONTACT_SUBMIT_BUTTON: 'Absenden',
    CONTACT_SUBMIT_SUCCESS: 'Die Nachricht wurde erfolgreich gesendet!',
    CONTACT_SUBMIT_FAILURE: 'Die Nachricht konnte nicht gesendet werden. Bitte überprüfe deine Angaben und versuche es erneut.',
    CONTACT_SUBMIT_FAILURE_500: 'Der Server ist zur Zeit überlastet. Versuche es später erneut.',

    CONTACT_VALIDATION_STRING: 'Gib mindestens ${min} Zeichen an.',
    CONTACT_VALIDATION_EMAIL: 'Gib eine gültige E-Mail-Adresse an.',
    CONTACT_VALIDATION_EMAIL_HINT: 'Wir benötigen deine E-Mail-Adresse, um zu antworten.',

    CONTACT_REASON_SUGGESTION: 'Verbesserungsvorschlag',

    FAQ_HEAD: 'Häufig gestellte Fragen',
    FAQ_INFO: <Fragment>
        Solltest du keine Antwort auf deine Frage finden, <strong><Link to={CONFIG.ROUTES.CONTACT}>kontaktiere uns</Link></strong> bitte.
    </Fragment>,
    FAQ_ENTRIES: [
        {
            name: 'Allgemein',
            entries: [
                [
                    'Gibt es euch noch?',
                    <Fragment>
                        <p>
                            Ja, uns gibt es noch.
                        </p>
                        <p>
                            Auch wenn es so aussehen mag, als hätten wir uns zurückgezogen, gehören Machinimas immer noch zu unseren Hobbies.
                        </p>
                    </Fragment>
                ],
                [
                    'Wann kommt das nächste Video?',
                    <Fragment>
                        <p>
                            Uff... Das lässt sich nicht so einfach beantworten.
                            Leider hat man nicht immer ausreichend Zeit, die man in seine Hobbies investieren kann.
                        </p>
                        <p>
                            Da dieses Hobby immer kürzer kommt, man aber die Qualität der Videos stetig verbessern möchte,
                            wird die Zeitspanne zwischen den Uploads auch immer größer.
                            Das tut uns leid, aber da es sich hierbei wirklich nur um ein Hobby handelt,
                            lässt sich an der Situtation aktuell auch nicht viel ändern.
                        </p>
                    </Fragment>
                ],
                [
                    'Wie kann man sich ein gesperrtes Video ansehen?',
                    <Fragment>
                        <p>
                            Leider sind über die Jahre manche Videos auf YouTube gesperrt worden.
                            Bisher war der Grund dafür immer das Verwenden von bestimmten Musiktiteln innerhalb der Videos.
                        </p>
                        <p>
                            Es handelte sich dabei zwar (laut YouTube) nicht um Urheberrechtsverstöße, aber die entsprechenden Rechteinhaber möchten die Verfügbarkeit einschränken/aufheben.
                            Mitunter wurden auch Videos, bei denen beanstandete Musiktitel ersetzt wurden, mit neuen Beanstandungen erneut gesperrt.
                        </p>
                        <p>
                            "Reuploads" wird es keine mehr geben.
                            Eventuell werden aber bei bereits hochgeladenen Videos betroffene Musiktitel entfernt, da YouTube diese Funktion mittlerweile anbietet, um die Sperrung eines Videos wieder aufzuheben.
                        </p>
                    </Fragment>
                ]
            ]
        },
        {
            name: 'Produktion',
            entries: [
                [
                    'Wie werden die Videos produziert?',
                    <Fragment>
                        <p>
                            Nachdem man die Idee zu einem Video hat und sich Gedanken über die Szenen gemacht hat, geht es zunächst darum, Spielszenen aufzunehmen.
                            Dafür kann man aus unterschiedlichen Programmen wählen.
                            Unter Windows gibt es beispielsweise die "Windows Game Bar" (Spieleleiste), mit NVIDIA Grafikkarten lässt sich "NVIDIA ShadowPlay" nutzen, oder klassisch mit Hilfe des Programms "Fraps".
                        </p>
                        <p>
                            "Grand Theft Auto IV" und "Grand Theft Auto V" bieten von Haus aus (für PC) die Möglichkeit, das Spielgeschehen aufzuzeichnen und sogar im Nachhinein zu bearbeiten.
                        </p>
                        <p>
                            Nach dem Aufzeichnen der Spielszenen geht es ans Editieren. Aus den einzelnen Szenen muss ein Video zusammengeschnitten werden.
                            Mit Videoschnittprogrammen wie "MAGIX Video Deluxe" oder "Sony Vegas Pro" lässt sich die eigene Kreativität voll ausleben.
                            Es gibt jedoch auch genug kostenfreie alternativen, die völlig ausreichend sind.
                        </p>
                        <p>
                            Ist das Video fertig, kann es gerendert (exportiert) und hochgeladen werden.
                        </p>
                    </Fragment>
                ],
                [
                    'Welche Spiele kommen zum Einsatz?',
                    <Fragment>
                        <p>
                            Grundsätzlich kann man aus jedem Spiel ein Video machen. Manche eignen sich gegebenfalls besser als andere.
                        </p>
                        <p>
                            Wir haben mit "Grand Theft Auto: San Andreas" angefangen und erstellen auch Videos mit "Grand Theft Auto V".
                            In "Grand Theft Auto III", "Grand Theft Auto: Vice City" und "Grand Theft Auto IV" wurden bisher nur wenige Szenen erstellt, die in anderen Videos verwendet wurden.
                        </p>
                        <p>
                            Für <Link to={CONFIG.ROUTES.PROJECTS + '#100.000 To Live Longer'}>100.000 To Live Longer</Link> wurde zu Beginn eine Szene aus "Call of Duty World at War" aufgezeichnet.
                        </p>
                        <p>
                            Geplant war auch ein Video mit Szenen aus "Mafia II".
                            Immersive Spiele wie "Star Citizen" oder "Red Dead Redemption 2" bieten sich ebenfalls für Machinimas an.
                        </p>
                        <p>
                            Und wer weiß, was uns in Zukunft noch für wundervolle Spiele erwarten?
                        </p>
                    </Fragment>
                ]
            ]
        },
        {
            name: 'SAMP',
            entries: [
                [
                    'Geht der INM SAMP-Server irgendwann wieder online?',
                    <Fragment>
                        <p>
                            Das ist aktuell leider nicht geplant.
                        </p>
                    </Fragment>
                ],
                [
                    'Seid ihr noch bei SAMP aktiv? Wenn ja, auf welchem Server / welchen Servern?',
                    <Fragment>
                        <p>
                            Nein, wir sind aktuell nicht mehr bei SAMP aktiv.
                        </p>
                    </Fragment>
                ]
            ]
        }
    ]
}, news, projects);
